<template>
  <div class="business-goods main-bg">
    <div class="main-wrap">
      <div class="mt20">
        <business-menu></business-menu>
        <div class="fr order-r">
          <div class="order-box mb10">
            <ul class="fl order-nav">
              <li :class="{'active':index==currentIndex}" v-for="(item,index) in goodsMenu" :key="index" @click="setGoodsStatus(item.id,index)">{{item.name}}</li>
            </ul>
            <div class="fr order-query">
              <el-input placeholder="请输入商品关键字" v-model="goodsKey">
                <el-button slot="append" @click="searchGoodsList()">搜索商品</el-button>
              </el-input>
            </div>
          </div>
          <el-table
                  class="tab-list"
                  :data="goodsData"
                  :header-row-style="{'background-color':'#EBF3EE','border':'1px solid #E0E0E0'}"
                  :header-cell-style="{
                  'background-color':'#F5F5F5',
                  'font-size':'14px',
                  'color':'#333333',
                  'height':'40px',
                  'padding':'0px',
                  'text-align':'left',
                  'font-weight':'500'}"
                  :cell-style="{'vertical-align': 'top'}"
          >
            <el-table-column
                    label="商品名称"
                    width="350"
                    align="left"
            >
              <template slot-scope="prop">
                <el-image class="goods-img" :src="$common.imgPath(prop.row.goodsLog)" :alt="prop.row.goodsLog" lazy></el-image>
                <div class="goods-name">{{prop.row.goodsName}}</div>
              </template>
            </el-table-column>
            <el-table-column
                    prop="stock"
                    label="库存">
            </el-table-column>
            <el-table-column
                    prop="price"
                    label="价格"
                    class-name="txt-16 font-500"
            >

            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="创建时间"
            >
              <template slot-scope="prop">
                <div>{{prop.row.createTime}}</div>
                <div class="main-color" v-text="prop.row.status===1?'出售中':'已下架'"></div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <button type="button" class="btn-base btn-mini btn-item" @click="lowerShelf(scope.$index, scope.row)" v-if="goodsType===1">立即下架</button>
                <button type="button" class="btn-base btn-mini btn-item" @click="upDownGoods(scope.$index, scope.row)" v-if="status===0&&scope.row.goodsType!==4">上架</button>
                <button type="button" class="btn-base btn-mini btn-item" @click="editGoodsInfo(scope.row)" v-if="status===0&&scope.row.goodsType!==4">编辑</button>
                <button type="button" class="btn-base btn-mini btn-item" @click="cancelAuction(scope.$index, scope.row)" v-if="goodsType===2">取消</button>
                <button type="button" class="btn-base btn-mini btn-item" @click="auctionEnd(scope.$index, scope.row)" v-if="goodsType===2">截拍</button>
                <button type="button" class="btn-base btn-mini btn-item" @click="delGoods(scope.$index, scope.row)" v-if="status===0">删除</button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="current"
                  layout=" prev, pager, next,total, jumper"
                  style="text-align: center;padding:20px;"
                  :total="total">
          </el-pagination>
        </div>
      </div>

    </div>


  </div>
</template>
<script>
  import BusinessMenu from '../../components/setting/businessMenu'
  import {findByShopIdForShop,cancelEndForShop,auctionEndForShop,upDownGoods,delGoodsForShop} from '../../api/goods'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
              currentIndex:0,
              status:1,
              goodsType:2,
              current:1,
              size:20,
              total:0,
              rank:1,//1默认 2销量 3价格
              goodsMenu:[
                  {
                      id:1,
                      name:'拍卖商品'
                  },
                  {
                      id:2,
                      name:'库存商品'
                  },
                  {
                      id:3,
                      name:'已下架'
                  }
              ],
              goodsKey:'',//商品关键字
              goodsData:[
                  {
                      xtImg:'',
                      name:'高端兰花限时出售-品种和细节点击查看',
                      stock:'1',
                      price:'123',
                      createTime:'2018-4-1'
                  }
              ]
          }
      },
      components:{
          BusinessMenu
      },
      created () {
          this.getShopGoodsList();
      },
      methods:{
          handleCurrentChange(current){
              this.current=current;
              this.getShopGoodsList();
          },
          setGoodsStatus(id,index){
              this.currentIndex=index;
              if(id===1){
                  this.goodsType=2;
                  this.status=1;
              }else if(id===2){
                  this.goodsType=1;
                  this.status=1;
              }else if(id===3){
                  this.goodsType='';
                  this.status=0
              }
              this.getShopGoodsList();
          },
          searchGoodsList(){
              this.current=1;
              this.getShopGoodsList()
          },
          getShopGoodsList(){
              let params={
                  shopId:this.userInfo.shopId,
                  current:this.current,
                  size:this.size,
                  status:this.status,
                  rank:this.rank,
                  goodsType:this.goodsType,
                  goodsName:this.goodsKey
              };
              if(this.goodsType===''){
                  delete params.goodsType;
              }
              if(this.goodsName===''){
                  delete params.goodsName;
              }
              findByShopIdForShop(params).then(res=>{
                  this.total=res.data.total;
                  this.goodsData=res.data.records;
              })
          },
          lowerShelf(index,row){
              let that = this ;
              this.$confirm('确定下架商品', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'info'
              }).then(() => {
                  upDownGoods({
                      shopId:this.userInfo.shopId,
                      goodsId:row.id,
                      status:0
                  }).then(()=>{
                      this.$message({
                          type: 'info',
                          message: '下架成功'
                      });
                      setTimeout(function () {
                          that.getShopGoodsList();
                      },1000)
                  })
              }).catch(() => {});
          },
          upDownGoods(index,row){
              let that = this ;
              this.$confirm('确定上架商品', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'info'
              }).then(() => {
                  upDownGoods({
                      shopId:this.userInfo.shopId,
                      goodsId:row.id,
                      status:1
                  }).then((res)=>{
                      this.$message({
                          message:res.msg,
                          type:'info'
                      });
                      setTimeout(function () {
                          that.getShopGoodsList();
                      },1000)
                  })
              }).catch(() => {});
          },
          delGoods(index,row){
              let that = this ;
              this.$confirm('确定删除此商品', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'info'
              }).then(() => {
                  delGoodsForShop(row.id).then(()=>{
                      this.$message({
                          type: 'info',
                          message: '删除成功'
                      });
                      setTimeout(function () {
                          that.getShopGoodsList();
                      },1000)
                  })
              }).catch(() => {});
          },
          cancelAuction(index,row){
              let that = this ;
              this.$confirm('确定取消竞拍', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'info'
              }).then(() => {
                  cancelEndForShop({
                      shopId:this.userInfo.shopId,
                      goodsId:row.id
                  }).then(()=>{
                      this.$message({
                          type: 'info',
                          message: '取消竞拍成功'
                      });
                      setTimeout(function () {
                          that.getShopGoodsList();
                      },1000)
                  })
              }).catch(() => {});
          },
          auctionEnd(index,row){
              let that = this ;
              this.$confirm('确定截拍？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'info'
              }).then(() => {
                  auctionEndForShop({
                      shopId:this.userInfo.shopId,
                      goodsId:row.id
                  }).then(()=>{
                      this.$message({
                          type: 'info',
                          message: '截拍成功'
                      });
                      setTimeout(function () {
                          that.getShopGoodsList();
                      },1000)
                  })
              }).catch(() => {});
          },
          editGoodsInfo(row){
              if(row.goodsType===1){
                  this.$router.push({'path':`/business/releaseGeneralGoods/${row.id}`})
              }else if(row.goodsType===2||row.goodsType===3){
                  this.$router.push({'path':`/business/releaseGoods/${row.id}`})
              }
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";
.tab-list{
  padding: 30px;
  .goods-img{
    float: left;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width:70px;
    height:70px;
  }
  .goods-name{
    float: left;
    width:207px;
    vertical-align: top;
    padding-left:10px;
    line-height: 24px;
    
  }
}
  .order-r{
    width:1000px;
    .order-box{
      padding: 25px 30px;
      background-color: #ffffff;
      overflow: hidden;
      .order-nav{
        overflow: hidden;
        li{
          float: left;color:#333;
          margin-right:47px;
          height:40px;
          font-size:20px;
          &.active{
            color:$main-color;
            font-weight:500;
            position: relative;
            &:after{
              content: '';
              position: absolute;
              bottom:6px;
              left:0;
              width:100%;
              height:3px;
              background-color:$main-color;
              -webkit-border-radius: 2px;
              -moz-border-radius: 2px;
              border-radius: 2px;
            }
          }
        }
      }

    }
.btn-item{
  background-color:#F5F5F5;
  &+.btn-item{margin-top:10px;}
}


  }
</style>
<style lang="scss">
  @import "../../assets/css/common";
  .order-query{
    width:230px;height:30px;
    border:1px solid #E0E0E0;
    .el-input__inner{
      font-size:12px;
      height:30px;
      line-height:30px;border:none;}
    .el-input-group__append, .el-input-group__prepend{
      font-size:12px;
      background-color:#F5F5F5;
      width:46px;
      padding:0 10px;
      border:none;
      color:#333;
      -webkit-border-radius: 0px;
      -moz-border-radius: 0px;
      border-radius: 0px;
    }
  }
  .tab-list{
    .el-table td{
      vertical-align: top;}
  }
</style>

